import { render, staticRenderFns } from "./search-suggestions-main-header.vue?vue&type=template&id=a800c702&scoped=true&"
import script from "./search-suggestions-main-header.vue?vue&type=script&lang=js&"
export * from "./search-suggestions-main-header.vue?vue&type=script&lang=js&"
import style0 from "./search-suggestions-main-header.vue?vue&type=style&index=0&id=a800c702&prod&lang=scss&"
import style1 from "./search-suggestions-main-header.vue?vue&type=style&index=1&id=a800c702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a800c702",
  null
  
)

export default component.exports